import { Navigate, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { logout } from '../redux-toolkit/features/slices/authSlice/authSlice';
import { useGetSingleUserDataQuery } from '../redux-toolkit/services/UserAuthApi/UserAuthApi';
import { Spinner } from 'react-bootstrap';

const PrivateRoute = () => {
    const dispatch = useDispatch();
    const { AuthInfo } = useSelector((state) => state?.auth);
    const { data, isLoading, error } = useGetSingleUserDataQuery(
        AuthInfo?._id,
        { skip: !AuthInfo?._id }
    );
    useEffect(() => {
        if (!data?.data?._id && !isLoading) {
            dispatch(logout());
        }
    }, [data]);

    if (isLoading) {
        return (<>
            <div style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <Spinner animation="border" variant="danger" />
            </div>
        </>);
    }

    return data?.data?._id ? <Outlet /> : <Navigate to='/unauthorized' replace />;
};
export default PrivateRoute;
 